import * as React from 'react';
import { Subscriber } from 'resources/types';
import PageColors, { PageColorsArguments } from 'page_colors';
const pageColors = new PageColors(window.pageColorData);
const styles = require('./styles.scss');

const Header = ({ children }: { children: React.ReactNode }) => <span style={{ color: pageColors.font.hex }}><strong>{children}</strong></span>;

declare global {
  interface Window {
    pageColorData: PageColorsArguments;
  }
}

interface HeadingProps {
  subscriber: Subscriber;
  onUnsubscribe(): void;
}

const Heading = ({ subscriber, onUnsubscribe }: HeadingProps) => {
  const mode = Subscriber.displayMode(subscriber);
  const identifier = Subscriber.identifier(subscriber);

  return (
    <div className={styles.subscriberHeading}>
      <Header>Subscriber</Header>
      <div className={styles.border} style={{ borderColor: pageColors.border.hex }}>
        <h2 className={styles.mode} style={{ color: pageColors.font.hex }}>{mode}</h2>
        <h3 className={styles.identifier} style={{ color: pageColors.font.hex }}>{identifier}</h3>

        <button
          className={styles.unsubscribeButton}
          style={{ color: pageColors.red.hex }}
          onClick={onUnsubscribe}>
          Cancel Subscription
        </button>
      </div>
    </div>
  );
};

export default Heading;



// WEBPACK FOOTER //
// ./app/javascript/containers/status/manage/heading.tsx